const mapping: Record<string, string> = {
  id: 'es=>es.Id',
  description: 'es=>es.Description',
}

export const mapSortEntrancesSetParam = (key: string) => mapping[key]
